// extracted by mini-css-extract-plugin
export default {"block":"Footer_block__tvxO5","copyright":"Footer_copyright__5vmix","socials":"Footer_socials__NL3d0","link":"Footer_link__8UN97"};